// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2qV7U","title":"Header_title__39JoX","left":"Header_left__chZqU","clinicName":"Header_clinicName__K9AAN"};